import {
  ChangeDetectionStrategy, Component, Input,
} from '@angular/core'
import { Icon } from '@knorr-bremse-portals/icons'

@Component({
  selector: 'kb-footer-icon-link',
  templateUrl: './footer-icon-link.component.html',
  styleUrls: ['./footer-icon-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FooterIconLinkComponent {
  @Input({ required: true }) public href!: string
  @Input() public target?: string
  @Input({ required: true }) public ariaLabel!: string
  @Input({ required: true }) public icon!: Icon
}
